if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;

        // START Clear Cart
        try {
          if (window.clearCartBeforeLocalizationAsync) {
            window.clearCartBeforeLocalizationAsync(form);
            return; // prevent double submit; the hook will submit
          }
        } catch (e) {}
        // END Clear Cart

        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}


// Clear-cart + badge sync for localization changes.
// Safe-guard to avoid double init if the file is included multiple times.
(function () {
  'use strict';
  if (window.__cccInit) return;
  window.__cccInit = true;

  function injectBadgeCSSOnce() {
    if (document.getElementById('ccc-badge-css')) return;
    var css = '.ccc-hide-badge .cart-count-bubble,.ccc-hide-badge .cart-icon-bubble,.ccc-hide-badge .cart-count,.ccc-hide-badge [data-cart-count]{visibility:hidden!important}';
    var style = document.createElement('style');
    style.id = 'ccc-badge-css';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  function ensureReturnToWithClear(form) {
    if (!form) return;
    var input = form.querySelector('input[name="return_to"]');
    var pathQuery = null;

    if (input && input.value) {
      try {
        var u = new URL(input.value, location.origin);
        u.searchParams.set('clear_cart', '1');
        pathQuery = u.pathname + u.search;
      } catch(e){}
    }
    if (!pathQuery) {
      var here = new URL(location.href);
      here.searchParams.set('clear_cart', '1');
      pathQuery = here.pathname + here.search;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = pathQuery;
  }

  function bestEffortClear() {
    try {
      if ('sendBeacon' in navigator) {
        navigator.sendBeacon('/cart/clear.js', '');
        return;
      }
    } catch(e){}
    try {
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', keepalive: true }).catch(function(){});
    } catch(e){}
  }

  function clearCartStrict(timeoutMs) {
    var ms = typeof timeoutMs === 'number' ? timeoutMs : 1500;
    return new Promise(function(resolve){
      try {
        var ctrl = ('AbortController' in window) ? new AbortController() : null;
        var t = setTimeout(function(){ try{ ctrl && ctrl.abort(); }catch(e){} resolve(); }, ms);
        fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          signal: ctrl ? ctrl.signal : undefined
        }).catch(function(){})
          .then(function(){ clearTimeout(t); resolve(); });
      } catch(e) {
        resolve();
      }
    });
  }

  function refreshBadgeThenUnhide() {
    function unhide() {
      document.documentElement.classList.remove('ccc-hide-badge');
      try { sessionStorage.removeItem('cccSuppressBadge'); } catch(e){}
    }
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
          var els = document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count, .cart-icon-bubble');
          els.forEach(function(el){
            if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(count));
            if (!el.querySelector('*')) el.textContent = String(count);
            if (count === 0) {
              el.classList.add('hidden', 'visually-hidden');
              if (el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true');
            } else {
              el.classList.remove('hidden', 'visually-hidden');
              if (el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'false');
            }
          });
        })
        .catch(function(){})
        .finally(unhide);
    } catch(e) {
      unhide();
    }
  }

  // Main hook called from onItemClick
  // Replace your existing hook with this
  window.clearCartBeforeLocalizationAsync = function(form) {
    if (!form) return;

    // Ensure redirect carries clear flag; hide badge to avoid flicker
    ensureReturnToWithClear(form);
    injectBadgeCSSOnce();
    document.documentElement.classList.add('ccc-hide-badge');
    try { sessionStorage.setItem('cccSuppressBadge', '1'); } catch(e){}

    // Always wait briefly so the next page renders with an empty cart
    clearCartStrict(900 /* ms */).finally(function(){
      HTMLFormElement.prototype.submit.call(form);
    });
  };

  // Arrival-side safety clear and badge sync (in case the first clear was cut off)
  // Replace your onArrival IIFE with this stricter version
  (function onArrival(){
    injectBadgeCSSOnce();
    var shouldHide = false;
    try {
      if (location.search.indexOf('clear_cart=1') > -1 || sessionStorage.getItem('cccSuppressBadge') === '1') {
        document.documentElement.classList.add('ccc-hide-badge');
        shouldHide = true;
      }
    } catch(e){}

    function setBadge(count) {
      var els = document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count, .cart-icon-bubble');
      els.forEach(function(el){
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(count));
        if (!el.querySelector('*')) el.textContent = String(count);
        if (count === 0) {
          el.classList.add('hidden', 'visually-hidden');
          if (el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true');
        } else {
          el.classList.remove('hidden', 'visually-hidden');
          if (el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'false');
        }
      });
    }

    function unhide() {
      document.documentElement.classList.remove('ccc-hide-badge');
      try { sessionStorage.removeItem('cccSuppressBadge'); } catch(e){}
    }

    var params = new URLSearchParams(location.search);
    if (params.get('clear_cart') === '1') {
      // Re-clear (safety), then clean URL and sync badge to 0 before unhide
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', keepalive: true }).catch(function(){});
      setTimeout(function(){
        params.delete('clear_cart');
        var newUrl = location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash;
        try { history.replaceState({}, '', newUrl); } catch(e){}

        // Fetch current count; if it fails, force 0 to avoid re-showing the bubble
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
            setBadge(count);
          })
          .catch(function(){
            setBadge(0);
          })
          .finally(unhide);
      }, 0);
    } else if (shouldHide) {
      // No clear_cart param (same-page switch), still sync and then unhide
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
          setBadge(count);
        })
        .catch(function(){
          setBadge(0);
        })
        .finally(unhide);
    }
  })();
})();
